module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"details":"Details"},"en":{"details":"Details"}}')
  delete Component.options._Ctor
}
